import { render, staticRenderFns } from "./ShopGroup.vue?vue&type=template&id=5b3cf63c&scoped=true&"
import script from "./ShopGroup.vue?vue&type=script&lang=js&"
export * from "./ShopGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3cf63c",
  null
  
)

export default component.exports